export const DELIVERY_CONSTANTS = {
  DELIVERY: {
    PICK_UP: '1',
    FAST: '2',
    PARCEL: '3',
  },
};
